<template>
  <div class="language-switcher">
    <div class="dropdown">
      <button
        class="btn btn-light btn-sm dropdown-toggle"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="flag-icon">{{ currentLanguageFlag }}</span>
        {{ currentLanguageName }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="languageDropdown">
        <li>
          <a
            class="dropdown-item"
            :class="{ active: locale === 'en' }"
            href="#"
            @click.prevent="changeLanguage('en')"
          >
            <span class="flag-icon">🇬🇧</span> English
          </a>
        </li>
        <li>
          <a
            class="dropdown-item"
            :class="{ active: locale === 'it' }"
            href="#"
            @click.prevent="changeLanguage('it')"
          >
            <span class="flag-icon">🇮🇹</span> Italiano
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n({ useScope: 'global' })

    const currentLanguageFlag = computed(() => {
      return locale.value === 'en' ? '🇬🇧' : '🇮🇹'
    })

    const currentLanguageName = computed(() => {
      return locale.value === 'en' ? 'English' : 'Italiano'
    })

    const changeLanguage = (lang) => {
      locale.value = lang
      localStorage.setItem('language', lang)
    }

    return {
      locale,
      currentLanguageFlag,
      currentLanguageName,
      changeLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}

.flag-icon {
  font-size: 1.2em;
  margin-right: 5px;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item.active {
  background-color: #0d6efd;
  color: white;
}

.dropdown-item:hover:not(.active) {
  background-color: #f8f9fa;
}
</style>
